class ActionTypeModel {
    static LEFT = "l";
    static RIGHT = "r";
    static CLOCKWISE = "c";
    static COUNTERCLOCKWISE = "o";
}

export default ActionTypeModel
